import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-teal-100 selection:text-teal-900 flex flex-col" data-id="element-98">
      <Header data-id="element-99" />
      <main className="flex-grow" data-id="element-100">
        <Outlet data-id="element-101" />
      </main>
      <Footer data-id="element-102" />
    </div>;
}